import React from 'react';
import styled from 'styled-components';
import { white } from '@spotify-internal/encore-foundation';
import { Type } from '@spotify-internal/encore-web';
import { Box } from '../../ui';
import { SearchBar } from '../../Search';

type HelpHeaderProps = {
  backgroundColor?: string;
};

const HeaderWrapper = styled(Box)<HelpHeaderProps>`
  background-color: ${(props: any) => props.backgroundColor};
  color: ${white};
  justify-content: center;
  height: 300px;
  background-image: url("
    data:image/svg+xml,%3Csvg
    stroke-width='0.99'
    viewBox='0 30 509 221'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'%3E%3Cpath
    d='M1.00003 221L364.231 -97L275 198L387.864 77.5L368.6 165L510 52.7467'
    stroke='%23${white}'/%3E%3C/svg%3E
  ");
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: right;
`;

const Header = styled.div`
  max-width: 984px;
  margin-left: auto;
  margin-right: auto;
`;

const Headline = styled(Type.h1).attrs({
  variant: Type.heading1,
  weight: Type.bold,
})<{}>`
  padding-top: 100px;
`;

export type HelpHeaderType = {
  headline: string;
  backgroundColor: string;
};

export const HelpHeader: React.FC<HelpHeaderType> = ({
  headline = '',
  backgroundColor,
}) => {
  return (
    <HeaderWrapper backgroundColor={backgroundColor}>
      <Header>
        <Headline>{headline}</Headline>
        <SearchBar
          placeholder="Search articles and resources"
          contentTypes={['faq']}
          trackCategory="helpHeader"
        />
      </Header>
    </HeaderWrapper>
  );
};
